import Observer from './observer.js'
import Impetus from 'impetus'

const AlphabetSrcoll = function(options) {
    this.container = $('.alphabetScroll');
    this.alphabet = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z']
    this.chars = []
    this.current = {
        char: null,
        charElement: null,
        charProduct: null
    }

    this.mobileScroll = 1
    this.lastX = 0

    this.jumpOptions = {
        // offset: -($('header').height() - 1),
        callback: () => {
            if (!window.isMobile) return
            this.scrolltoIndex()
        }
    }

    // init observer
    this.observer = new Observer({
        callback: (entries, observer) => {
            entries.forEach(entry => {
                // console.log(entry.target, entry.isIntersecting, entry.intersectionRect)
                if (entry.isIntersecting ) {
                    if (entry.intersectionRect.height > window.innerHeight / 2) {
                        const entryChar = $(entry.target).attr('data-alphabet')

                        if (entryChar !== this.current.char) {
                            this.current = {
                                char: entryChar,
                                charElement: $('.alphabet-char#'+entryChar),
                                charProduct: entry.target
                            }
                            // console.log(this.current)

                            if ('MatomoTracker' in window) MatomoTracker.trackEvent('Enter Product', this.current.charElement.find('.product-title').text())

                            if (!window.isMobile) {
                                $('.alphabet-char').removeClass('active')
                                this.current.charElement.addClass('active')
                            } else {
                                this.scrolltoIndex()
                            }

                            window.location.hash = this.current.char
                        }   
                    }
                }
            });
        }
    })

    this.scrolltoIndex = () => {
        if (!this.current.char) return
        const currentIndex = this.current.charElement.index()
        const scrollIndex = currentIndex === 0 ? 1 : currentIndex + 1
        this.mobileScrollTo(scrollIndex * 0.3333)                    
    }

    this.mobileScrollTarget = null;
    this.mobileScrollTo = (target) => {
        const startTime = new Date().getTime(),
        start = this.mobileScroll,
        end = target,
        duration = 2000;

        this.mobileScrollTarget = end

        // Takes one step forward in the animation
        const step = (end) => {
            // Ease out equation over the specified duration
            var progress = 1 - Math.pow( 1 - ( ( new Date().getTime() - startTime ) / duration ), 5 );
                
            // Update styles to match current interpolated values
            this.mobileScroll = start + ( ( end - start ) * progress );
            this.updateCharElements()

            // Repeat the above if we're not done
            if( progress < 1 && this.mobileScrollTarget === end ) {
                setTimeout( step, 1000 / 60, end );
            }
        }

        // Start the animation
        step(end);
    }

    this.updateCharElements = () => {
        const m = 3;
        let highest = 0;
        let active = null
        const ww = window.innerWidth
        // console.log("update", this.mobileScroll)
        this.chars.forEach((c,x) => {
            let cVal = -Math.pow(((x + 1) / m) - this.mobileScroll, 2) + 1
            // let cVal = -Math.pow((x + 1) - this.mobileScroll, 2) + 1
            const cBasis = cVal > 0 ? (cVal * (ww / m)) + "px" : 0
            // console.log(x, cVal, cBasis)
            if (cVal < 0) {
                c.addClass('unset')
            } else {
                c.removeClass('unset')
                // c.css('flex-grow',cVal)
                c.css('flex-basis',cBasis)
                if (cVal > highest) {
                    highest = cVal
                    active = c
                }
            }

            c.removeClass('active')
        })

        if (active[0].hasOwnProperty('product')) {
            active.addClass('active')
            active.css('flex-grow',2)
        }
    } 

    this.createElements = () => {
        // create elements
        for (let c = 0; c < this.alphabet.length; c++) {
            const charElement = $('<div class="alphabet-char"></div>')
            const char = this.alphabet[c]
            const charProduct = $('.product[data-alphabet="'+char+'"]')
            
            charElement.attr('id',char)
            charElement.text(this.alphabet[c].toUpperCase())

            if (charProduct.length > 0) {
                const charProductTitle = charProduct.find('h2').text()
                const collabLabel = charProduct.find('#collaborationLabel')
                const charProductTitleElement = $('<div class="product-title"></div>')

                charProductTitleElement.text(charProductTitle)
                if (collabLabel.length > 0) charProductTitleElement.append(collabLabel.clone())

                charElement.append(charProductTitleElement)

                charElement[0].product = charProduct

                this.observer.observe(charProduct[0])
            }

            charElement.on('click', (e) => {
                const charEl = $(e.target).parent()
                const charProduct = charEl[0].product

                if ('MatomoTracker' in window) MatomoTracker.trackEvent('Clicked Char', $(e.target).text())

                console.log("click", charProduct)

                if (charProduct) {
                    this.isJumping = true
                    console.log(window.jump)
                    window.jump(charProduct[0], this.jumpOptions)
                }
            })
            
            this.chars.push(charElement)
            this.container.append(charElement)
        }
    }

    this.init = function() {
        this.createElements()

        // init listeners
        if (window.isMobile) {
            new Impetus({
                source: this.container[0],
                update: (x, y) => {
                    console.log("scroll")
                    // whatever you want to do with the values
                    // console.log("x: " + x, "lastX: " + this.lastX)
                    if (this.lastX != 0) this.mobileScroll += (this.lastX - x) / 100
                    if (this.mobileScroll < 0.33) this.mobileScroll = 0.33
                    if (this.mobileScroll >= 8.77) this.mobileScroll = 8.77
                    this.lastX = x

                    // console.log(this.mobileScroll)

                    this.updateCharElements()
                }
            });
        } else {
            $('.alphabet-char').on('mouseenter', function() {
                $('.alphabet-char').removeClass('active')
                $(this).addClass('active')
            })

            $('.alphabet-char').on('mouseleave', function() {
                $(this).removeClass('active')
            })
    
            this.container.on('mouseleave', () => {
                this.current.charElement.addClass('active')
            })
        }
        
        // sroll to hash
        const hash = window.location.hash
        if (hash) {
            const char = hash.replace('#','')
            this.isJumping = true
            window.jump($('.product[data-alphabet='+char+']')[0], this.jumpOptions)
        }
    }
}

export default AlphabetSrcoll